import { getStorage } from 'firebase/storage';
import { app } from './firebase.js';
const storage = app ? getStorage(app) : false;
export default storage;
